import { render, staticRenderFns } from "./Proform-Listing.vue?vue&type=template&id=78327660"
import script from "./Proform-Listing.vue?vue&type=script&lang=js"
export * from "./Proform-Listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports